<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header" style="background-color: white !important;">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">STUDENT FEEDBACK</h4>
            </div>
        </div>
        <div *ngIf="!tableshow" style="margin-left: 50%;">
            <div class="loader"></div>
        </div>


        <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>Mentor Name</th>
                            <th>Course Name</th>
                            <th>Course Topic</th>
                            <th>Course Start </th>
                            <th>Course Time </th>
                            <th>FEEDBACK</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let customer of enrolledCourses">
                            <td style="min-width: 20px;">
                                {{customer['mentor_name']}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer['course_name']}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer['typeofcourse']}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer['course_date'] | date:'dd-MM-YYYY'}} 
                            </td>
                            <td style="min-width: 20px;">
                             {{customer['course_time']}}
                            </td>

                            <!-- <td [hidden]="isButtonDisabled"> -->
                                <td>
                                <!-- <a data-toggle="modal" data-target="#showCM"
                                    class="btn btn-primary btn-circle btn-sm"
                                    (click)="buttonviewmeeting(customer,'show')"
                                    [hidden]="feedbackStudent(customer)">
                                    <i class="fas fa-flag" ></i>
                                </a> -->

                                <a data-toggle="modal" data-target="#showCM"
   [ngClass]="{
      'btn btn-danger btn-circle btn-sm': feedbackStudent(customer),
      'btn btn-primary btn-circle btn-sm': !feedbackStudent(customer)
    }"
   (click)="buttonviewmeeting(customer, 'show')"> 
   <i class="fas fa-flag"></i>
</a>

                            </td>

                            <ng-template #notShow [hidden]="isButtonDisabled">
                                <a *ngIf="customer.status=='cancel'">
                                    Cancelled

                                </a>
                            </ng-template>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>


        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card-success">
                        <div class="card-header">
                            <h3 class="card-title">STUDENT FEEDBACK </h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Course Name<span class="pull-right"> :</span></h6>
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                     CM_course_name   }}</h6>
                                </div>
                            </div>

                          
                                <div class="col-6 col-sm-12 col-md-6 row" style="margin-left: 1%;">
                                    <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Mentor<span class="pull-right"> :</span></h6>
                                   
                                     </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_mentor_name  }}</h6>
                                 </div>
                                </div>    
                                </div>
                                <div class= "row mb-2" *ngIf="!editfield" >

                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                                <h6 class="f-w-500">Course Topic<span class="pull-right"> :</span></h6>
                                         </div>
                                        <div class="col-sm-6 col-6" >
                                            <h6>
                                               {{CM_typeofcourse}}
                                         </h6>
                                        </div>
                                       </div>


                            <div class="col-6 col-sm-12 col-md-6 row" style="margin-left: 1%;">
                                          <div class="col-sm-6 col-6" >
                                                <h6 class="f-w-500">Course Location<span class="pull-right"> :</span></h6>
                                           </div>
                                          <div class="col-sm-6 col-6" ><h6>
                                                 Online
                                           </h6>
                                         </div>
                                   </div>
                                    <!-- <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">No. of Registered Students<span class="pull-right"> :</span></h6>
                                    </div>
                                    <div class="col-sm-6 col-6" ><h6>
                                        {{CM_no_of_students}}
                                       </h6>
                                </div>
                            </div> -->
                            <!-- <div class="col-6 col-sm-12 col-md-6 row" style="margin-left: 1%;">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">No. of Presentees <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6" ><h6>
                                     {{  CM_students_attendance.split(" ").length }}
                                    </h6>
                            </div>
                        </div> -->
    
                                </div>
                                <!-- <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row" >
                                        <div class="col-sm-6 col-6" >
                                            <h6 class="f-w-500">No. of Absentees <span class="pull-right"> :</span></h6>
                                           
                                        </div>
                                        <div class="col-sm-6 col-6" ><h6>
                                             {{ CM_no_of_students - CM_students_attendance.split(" ").length }}
                                            </h6>
                                    </div>
                                </div>
                                    <div class="col-6 col-sm-12 col-md-6 row" style="margin-left: 1%;">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Course Location <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                     CM_location  }}</h6>
                                </div>
                            </div>
                           
                        </div> -->
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Course Start Date<span class="pull-right"> :</span></h6>
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                     CM_startDate   }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row" style="margin-left: 1%;">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Course Time<span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_course_time  }}</h6>
                            </div>
                        </div>
    
                                </div>
                                
                              
                              
                                <div class="row" *ngIf="!editfield">
                                    <div class="col-md-6">
                                        <label for="" class="form-label">Topic Clarity<a
                                                style="color:red">*</a></label>
                                        <div class="rating">

                                            <input type="radio" formControlName="topic_clarity" value="5"
                                                id="5"><label for="5">☆</label>
                                            <input type="radio" formControlName="topic_clarity" value="4"
                                                id="4"><label for="4">☆</label>
                                            <input type="radio" formControlName="topic_clarity" value="3"
                                                id="3"><label for="3">☆</label>
                                            <input type="radio" formControlName="topic_clarity" value="2"
                                                id="2"><label for="2">☆</label>
                                            <input type="radio" formControlName="topic_clarity" value="1"
                                                id="1"><label for="1">☆</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="" class="form-label">Overall Co-Ordination<a
                                                style="color:red">*</a></label>
                                        <div class="rating2">

                                            <input type="radio" formControlName="overall_co_ordination" value="5"
                                                id="6"><label for="6">☆</label>
                                            <input type="radio" formControlName="overall_co_ordination" value="4"
                                                id="7"><label for="7">☆</label>
                                            <input type="radio" formControlName="overall_co_ordination" value="3"
                                                id="8"><label for="8">☆</label>
                                            <input type="radio" formControlName="overall_co_ordination" value="2"
                                                id="9"><label for="9">☆</label>
                                            <input type="radio" formControlName="overall_co_ordination" value="1"
                                                id="10"><label for="10">☆</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" *ngIf="!editfield">
                                    <div class="col-md-6">
                                        <label for="" class="form-label">Overall Understanding/Usefullness of Session<a
                                                style="color:red">*</a></label>
                                        <div class="rating3">

                                            <input type="radio" formControlName="overall_understanding" value="5"
                                                id="11"><label for="11">☆</label>
                                            <input type="radio" formControlName="overall_understanding" value="4"
                                                id="12"><label for="12">☆</label>
                                            <input type="radio" formControlName="overall_understanding" value="3"
                                                id="13"><label for="13">☆</label>
                                            <input type="radio" formControlName="overall_understanding" value="2"
                                                id="14"><label for="14">☆</label>
                                            <input type="radio" formControlName="overall_understanding" value="1"
                                                id="15"><label for="15">☆</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="" class="form-label">Engagement and Interaction.<a
                                                style="color:red">*</a></label>
                                        <div class="rating4">

                                            <input type="radio" formControlName="facilities_in_venue" value="5"
                                                id="16"><label for="16">☆</label>
                                            <input type="radio" formControlName="facilities_in_venue" value="4"
                                                id="17"><label for="17">☆</label>
                                            <input type="radio" formControlName="facilities_in_venue" value="3"
                                                id="18"><label for="18">☆</label>
                                            <input type="radio" formControlName="facilities_in_venue" value="2"
                                                id="19"><label for="19">☆</label>
                                            <input type="radio" formControlName="facilities_in_venue" value="1"
                                                id="20"><label for="20">☆</label>
                                        </div>
                                    </div>
                                </div>
                           
                                <div class="row" *ngIf="!editfield">
                                    <div class="col-md-6">
                                        <label for="" class="form-label">Overall Rating About Session<a
                                                style="color:red">*</a></label>
                                        <div class="rating5">

                                            <input type="radio" formControlName="overall_rating_about_session" value="5"
                                                id="21"><label for="21">☆</label>
                                            <input type="radio" formControlName="overall_rating_about_session" value="4"
                                                id="22"><label for="22">☆</label>
                                            <input type="radio" formControlName="overall_rating_about_session" value="3"
                                                id="23"><label for="23">☆</label>
                                            <input type="radio" formControlName="overall_rating_about_session" value="2"
                                                id="24"><label for="24">☆</label>
                                            <input type="radio" formControlName="overall_rating_about_session" value="1"
                                                id="25"><label for="25">☆</label>
                                        </div>
                                    </div>

                                </div>
                                    <div class="form-group row" *ngIf="!editfield">
                                        <div class="col-md-12">
                                            <label>Comments</label>
                                            <textarea class="form-control" formControlName="comments"></textarea>
                                        </div>
                                    </div>


                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Course Name </label><span class="required "> *</span>
                                        <select name="course_name" class="form-control" formControlName="course_name"
                                            [(ngModel)]="CM_course_name">
                                            <option value="">Select Course Name</option>
                                            <option *ngFor="let option of courses" [value]="option.id">
                                                {{option['course_name']}}</option>

                                        </select>

                                    </div>


                                </div>
                                <div class="form-group row" *ngIf="editfield">

                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Organizer</label><span class="required "> *</span>
                                        <select name="organizer" class="form-control" formControlName="organizer"
                                            [(ngModel)]="CM_organizer">
                                            <option value="">Select Organizer</option>
                                            <option value="class">Class</option>
                                            <option *ngFor="let option of ob_data" (value)="option['firstname']">
                                                {{option['firstname']}}</option>

                                        </select>

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Start Date</label><span
                                            class="required">*</span>
                                        <input pInputText type="date" class="form-control"
                                            placeholder="Enter Course Start Date" [value]="CM_startDate">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course End Date</label><span class="required">*</span>
                                        <input pInputText type="date" class="form-control"
                                            placeholder="Enter Course End Date" [value]="CM_endDate">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Start Time</label><span
                                            class="required">*</span>
                                        <input pInputText type="time" class="form-control"
                                            placeholder="Enter Course Start Time" [value]="CM_startTime">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course End Time</label><span class="required">*</span>
                                        <input pInputText type="time" class="form-control"
                                            placeholder="Enter Course End Time" [value]="CM_endTime">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Primary Volunteer</label><span
                                            class="required">*</span>
                                        <input pInputText type="text" class="form-control"
                                            placeholder="Enter Primary Volunteer" [value]="CM_volunteer1">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Secondary Volunteer</label><span
                                            class="required">*</span>
                                        <input pInputText type="text" class="form-control"
                                            placeholder="Enter Secondary Volunteer" [value]="CM_volunteer2">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Location</label><span class="required">*</span>
                                        <input pInputText type="text" class="form-control"
                                            placeholder="Enter Course Location" [value]="CM_location">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Status</label><span class="required">*</span>
                                        <select name="status" class="form-control" formControlName="status"
                                            [(ngModel)]="CM_status">
                                            <option value="">Select any status </option>
                                            <option>Open</option>
                                            <option>Session Start</option>
                                            <option>Session End</option>
                                            <option>Inprogress</option>
                                            <option>Cancelled</option>
                                            <option>Postponed</option>
                                        </select>

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-md-12">
                                        <label>Comments</label>
                                        <textarea class="form-control" formControlName="comments"
                                            [value]="CM_comments"></textarea>
                                    </div>
                                </div>

                                <div *ngIf="!editfield" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-success btn btn-block" [hidden]="hidebutton">Submit Feedback</button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>